<template>
    <div class="fullscreen bg_market">
        <div class="logo"></div>
        <div class="menu" @click="showFullSwiper"></div>
        <header>
            <h1 class="title">全装修市场监控系统</h1>
            <p class="title--sub">数据统计时间：{{countTime.sStartTime}}-{{countTime.sEndTime}}</p>
        </header>
        
        <div class="main flex_justify_between">
            <div class="main--left">
                <div class="box_normal subscript right_bottom left_top mb_15">
                    <div class="box_unit_title mb_15 c_pointer" @click="labelClick('normal')">
                        全装修项目建面TOP10城市
                        <div class="unit">({{cityTopTenData.Header}})</div>
                    </div>
                    <SwiperList
                        theme="blue"
                        :hasInnerSplit="true"
                        :hasValue="true"
                        iconType="triangle"
                        iconPosition="after"
                        :perBaseData="cityTopTenData.AllArea"
                        :showData="cityTopTenData.aCity"
                        @labelClick="(name)=>labelClick('city',name)">
                    </SwiperList>
                    <!-- <ul class="progressbarList sort mt_5">
                        <li class="item" v-for="(item,index) in cityTopTenData.aCity" :key="index">
                            <div class="sortIcon">{{index+1}}</div>
                            <div class="label">{{item.sName}}</div>
                            <div class="valueBar flex_align">
                                <div class="innerBar blue" :style="{'width':item.sValue*0.76+'%'}">
                                    <div class="innerSplit"></div>
                                </div>
                                {{item.sValue}}
                            </div>
                            <div class="value"> -->
                                <!-- {{parseInt(Math.abs(item.iRange)*100)}}% -->
                                <!-- {{parseInt(item.iRange*100)}}%
                                <i class="iconfont" :class="{
                                    'icon-iconfont_up':item.iRangeType==1,
                                    'icon-iconfont_down1':item.iRangeType==2,
                                }"></i>
                            </div>
                        </li> -->
                    <!-- </ul> -->
                </div>
                <div class="box_normal subscript right_bottom left_top mb_15">
                    <div class="box_unit_title mb_15 c_pointer" @click="labelClick('normal')">
                        全装修项目建面TOP10房企
                        <div class="unit">({{companyTopTenData.Header}})</div>
                    </div>
                    <SwiperList
                        theme="green"
                        :hasInnerSplit="false"
                        :hasValue="true"
                        iconType="triangle"
                        iconPosition="after"
                        labelType="longLabel"
                        :perBaseData="companyTopTenData.AllArea"
                        :showData="companyTopTenData.aCity"
                        @labelClick="(name)=>labelClick('company',name)">
                    </SwiperList>
                    <!-- <ul class="progressbarList mt_5">
                        <li class="item" v-for="(item,index) in companyTopTenData.aCity" :key="index">
                            <div class="label">{{item.sName}}</div>
                            <div class="valueBar flex_align">
                                <div class="innerBar green" :style="{'width':item.sValue*0.76+'%'}"></div>
                                {{item.sValue}}
                            </div>
                            <div class="value">
                                {{parseInt(item.iRange*100)}}%
                                <i class="iconfont" :class="{
                                    'icon-iconfont_up':item.iRangeType==1,
                                    'icon-iconfont_down1':item.iRangeType==2,
                                }"></i>
                            </div>
                        </li>
                    </ul> -->
                </div>
                <div class="box_normal subscript right_bottom left_top">
                    <div class="box_unit_title mb_15 c_pointer" @click="labelClick('normal')">
                        房企全装修交付覆盖率
                    </div>
                    <div class="flex_justify_between position_r">
                        <div class="pieChartBox">
                            <Echarts :options="getOptions('nestingPie',deliveryCoverData)"></Echarts>
                        </div>
                        <ul class="pieChartList">
                            <li class="item title">
                                <span class="label">房企</span>
                                <span class="value">覆盖率</span>
                            </li>
                            <li class="item flex_justify_between" v-for="(item,index) in deliveryCoverData" :key="index">
                                <span class="label c_pointer" @click="labelClick('company',item.sCompany)">{{item.sCompany}}</span>
                                <span class="value">{{item.iDecorateRate}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="main--middle">
                <div class="box_chart--doubleLine box_normal subscript right_bottom left_top mb_15">
                    <div class="detailBox">
                        <div class="item">
                            <p class="label">全装修面积({{areaCountHead.AreaUnit}})</p>
                            <p>
                                <span class="value c_area2">{{areaCountHead.TotalBuildArea}}</span>
                                <span class="ratio">环比 {{areaCountHead.iAreaPercent}}</span>
                                <i
                                    class="iconfont icon-iconfont_up"
                                    :class="{'icon-iconfont_down1':areaCountHead.iAreaType=='2'}">
                                </i>
                            </p>
                        </div>
                        <div class="item">
                            <p class="label">全装修套数({{areaCountHead.countUnit}})</p>
                            <p>
                                <span class="value c_count2">{{areaCountHead.PlanCounts}}</span>
                                <span class="ratio">环比 {{areaCountHead.iCountPercent}}</span>
                                <i
                                    class="iconfont icon-iconfont_up"
                                    :class="{'icon-iconfont_down1':areaCountHead.iCountType=='2'}">
                                </i>
                            </p>
                        </div>
                    </div>
                    <div class="chartsBox">
                        <Echarts :options="getOptions('base',linechartsData)"></Echarts>
                    </div>
                </div>
                <div class="box_map subscript right_bottom left_top">
                    <!-- 地图 -->
                    <div class="map-content" ref="zfyxMap"></div>

                    <div class="mapTitle ">全装修项目分布图</div>

                    <!-- 新版地图柱状缩略图 -->
                    <div class="map-chart">
                        <Echarts ref="mapBar" v-if="mapBarData" :options="getOptions('mapBar',mapBarData)" @chartClick="mapBarClick($event)"></Echarts>
                    </div>

                    <!-- 旧版热力图列表 -->
                    <!-- <div class="hotmapList">
                        <div class="item head mb_10">
                            <span>城市</span>
                            <span>项目数</span>
                        </div>
                        <div class="hotmapList_main" v-if="projectSpreadData&&projectSpreadData.length">
                            <ScrollBox :autoplay='false'>
                                <ul slot="main">
                                    <li
                                    class="item"
                                    :class="{'active':activeCity==item.CityCaption}"
                                    v-for="(item,index) in projectSpreadData"
                                    :key="index"
                                    @click="onHotmap(item)">
                                        <span>{{item.CityCaption}}</span>
                                        <span>{{item.count}}</span>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="main--right">
                <div class="box_cutAngle--bg subscript right_bottom left_top mb_15 position_r">
                    <p class="box_cutAngle_title fs_18 c_pointer" @click="labelClick('normal')">全装修趋势</p>
                    <div class="box_cutAngle_splitline type2"></div>
                    <swiper :options="baseSwiperOption" ref="myBaseSwiper">
                        <!-- slides -->
                        <swiper-slide>
                            <div class="box-chart--ladderBar flex_wrap">
                                <div class="w_45 h_100">
                                    <Echarts :options="getOptions('pie',tabChartsData1)"></Echarts>
                                    <!-- canvas 无label版本（备用） -->
                                    <!-- <DonutChart
                                        :chartData="DonutChartData1"
                                        title="建筑面积占比"
                                        color="#00FFFF"
                                        centerTxt="全装修"
                                        :centerValue="areaDirection.iFullCnt+areaDirection.areaHeader">
                                    </DonutChart> -->
                                </div>
                                <div class="w_55 h_100">
                                    <Echarts :options="getOptions('pie',tabChartsData2)"></Echarts>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="box-chart--ladderBar flex_wrap">
                                <div class="w_45 h_100">
                                    <Echarts :options="getOptions('pie',tabChartsData3)"></Echarts>
                                    <!-- <Echarts :options="getOptions('donutPie',tabChartsData3)"></Echarts> -->
                                </div>
                                <div class="w_55 h_100">
                                    <Echarts :options="getOptions('pie',tabChartsData4)"></Echarts>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <i class="iconfont icon-iconfont_arrowL arrow_l" id="baseArrowL"></i>
                    <i class="iconfont icon-iconfont_arrowR arrow_r" id="baseArrowR"></i>
                </div>
                <div class="box_cutAngle--bg cutAngle_box subscript right_bottom left_top">
                    <p class="box_cutAngle_title fs_18 c_pointer" @click="labelClick('normal')">新开盘全装修项目</p>
                    <div class="tableList market_newopen">
                        <div class="item head">
                            <div class="cell">项目名称</div>
                            <div class="cell">开发商</div>
                            <div class="cell">建面({{newProjectListData.Header}})</div>
                            <div class="cell">套数</div>
                        </div>
                        <div class="tableList_main" v-if="newProjectListData.aList&&newProjectListData.aList.length">
                            <ScrollBox :num='newProjectListData.aList.length'>
                                <ul slot="main">
                                    <li class="item c_pointer" v-for="(item,index) in newProjectListData.aList" :key="index" @click="toDetail(item.SolutionID)">
                                        <div class="cell">{{item.Caption}}</div>
                                        <div class="cell" :title="item.Developer">{{item.Developer}}</div>
                                        <div class="cell">{{item.TotalBuildArea}}</div>
                                        <div class="cell">{{item.PlanCounts}}</div>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                        <!-- <ul class="tableList_main">
                            <li class="item" v-for="(item,index) in newProjectListData.aList" :key="index">
                                <div class="cell">{{item.Caption}}</div>
                                <div class="cell">{{item.Developer}}</div>
                                <div class="cell">{{item.TotalBuildArea}}</div>
                                <div class="cell">{{item.PlanCounts}}</div>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import Echarts from "@/components/Echarts";
import DonutChart from "@/components/DonutChart";
import getCharts from "@/utils/getCharts.js";
import { swiper, swiperSlide} from 'vue-awesome-swiper'
import ajaxService from '@/server/api.js'
import chartSet from "@/config/chartSet";
import permission from "@/mixins/permission.js";
import { loadAmap, createFullscreenAmap, createCountryDistrictLayer, bd09ToGcj02 } from "@/utils/amapCommon.js";
const MARKET_MAP_CENTER = [104.195397, 35.86166];
const MARKET_MAP_ZOOM = 12.8;
export default {
    mixins:[permission],
    data(){
        return {
            map: null,
            AMap: null,
            districtLayer: null,
            richMarker: null,
            pointMarkers: [],
            isMapReady: false,
            mapCenter: MARKET_MAP_CENTER,
            countTime:{},//统计时间 sStartTime sEndTime
            cityTopTenData:{},//建面TOP10城市数据
            companyTopTenData:{},//建面TOP10房企数据
            deliveryCoverData:[],//房企全装修交付覆盖率数据（环形嵌套）
            newProjectListData:{},//新开盘全装修项目列表数据（表格）
            areaCountHead:{},//装修面积&装修套数（双折线图-头部）
            areaCountChart:[],//装修面积&装修套数（双折线图-图表）
            areaDirection:{},//建筑面积占比（饼图1&3）
            decorationStandard:{},//装修标准占比（饼图2）
            projectTypeData:{},//项目类型占比（饼图4）
            projectSpreadData:[],//全装修项目分布图（热力图）
            baseSwiperOption: {
                navigation: {
                    nextEl: '#baseArrowR',
                    prevEl: '#baseArrowL',
                    disabledClass: 'disabled',
                },
            },
            activeCity:'',

            mapBarData:null,//地图柱状缩略图
            mapBarDataMax:null,
            landList:[],
        }
    },
    computed: {
        linechartsData(){//双折线图data
            let xData=[];
            let seriesData=[
                {type:'line',value:[],name:'全装修面积',color:['rgba(0, 255, 255, 0.5)','rgba(0, 255, 255, 0)'],lineColor:'#00FFFF',unit:this.areaCountHead.AreaUnit},
                {type:'line',value:[],name:'全装修套数',color:['rgba(0, 125, 234, 0.5)','rgba(0, 125, 234, 0)'],lineColor:'#007DEA',unit:this.areaCountHead.countUnit},
            ];
            this.areaCountChart.forEach((item,index)=>{
                xData.push(item.sCateDesc)
                seriesData[0].value.push(item.TotalBuildArea)
                seriesData[1].value.push(item.PlanCounts)
            })
            return chartSet.areaCountChart(xData,seriesData)
        },
        tabChartsData1(){
            // return chartSet.tabPieChart1(this.areaDirection)
            return chartSet.tabDonutPieChart(this.areaDirection)
        },
        tabChartsData2(){
            return chartSet.tabPieChart2(this.decorationStandard)
        },
        tabChartsData3(){
            // return chartSet.tabPieChart1(this.areaDirection,2)
            return chartSet.tabDonutPieChart(this.areaDirection,2)
        },
        tabChartsData4(){
            return chartSet.tabPieChart4(this.projectTypeData)
        },
        DonutChartData1(){
            return {
                name:'全装修',
                value: this.areaDirection.iAreaCover,
            }
        }
    },
    components: {
        Echarts,
        DonutChart,
        swiper,
        swiperSlide
    },
    mounted() {
        this.initData()
        this.initAmap()
        document.title="全装修市场监控系统 - 优采大数据"
    },
    beforeDestroy() {
        clearInterval(this.MapTimmer);
        this.destroyMap();
    },
    methods: {
        async initAmap() {
            try {
                const AMap = await loadAmap({
                    plugins: ['AMap.Scale'],
                });

                if (this._isDestroyed || this._isBeingDestroyed || !this.$refs.zfyxMap) {
                    return;
                }

                this.AMap = AMap;
                this.map = createFullscreenAmap(AMap, this.$refs.zfyxMap, {
                    center: this.mapCenter,
                    zoom: MARKET_MAP_ZOOM,
                });
                this.drawAllProvinceBoundaries();
                this.isMapReady = true;
                this.tryRenderMarketMap();
            } catch (error) {
                console.error('高德地图初始化失败', error);
            }
        },
        destroyMap() {
            this.clearMarketOverlays();

            if (this.districtLayer && this.districtLayer.setMap) {
                this.districtLayer.setMap(null);
            }

            this.districtLayer = null;
            this.isMapReady = false;

            if (this.map) {
                this.map.destroy();
            }

            this.map = null;
            this.AMap = null;
        },
        drawAllProvinceBoundaries() {
            if (!this.AMap || !this.map) {
                return;
            }

            if (this.districtLayer && this.districtLayer.setMap) {
                this.districtLayer.setMap(null);
            }

            this.districtLayer = createCountryDistrictLayer(this.AMap, this.map, {
                'nation-stroke': 'rgba(6, 104, 186, 0.55)',
                'coastline-stroke': 'rgba(6, 104, 186, 0.55)',
                'province-stroke': 'rgba(6, 104, 186, 0.35)',
                fill: 'rgba(6, 104, 186, 0.03)',
            });
        },
        parsePoint(rawPoint) {
            if (!rawPoint) {
                return null;
            }

            let lng;
            let lat;

            if (Array.isArray(rawPoint)) {
                lng = parseFloat(rawPoint[0]);
                lat = parseFloat(rawPoint[1]);
            } else if (typeof rawPoint === 'string') {
                const pointArr = rawPoint.split(',');
                lng = parseFloat(pointArr[0]);
                lat = parseFloat(pointArr[1]);
            } else if (typeof rawPoint === 'object') {
                lng = parseFloat(rawPoint.lng || rawPoint.longitude || rawPoint.X || rawPoint.x);
                lat = parseFloat(rawPoint.lat || rawPoint.latitude || rawPoint.Y || rawPoint.y);
            }

            if (isNaN(lng) || isNaN(lat)) {
                return null;
            }

            return bd09ToGcj02(lng, lat);
        },
        clearMarketOverlays() {
            if (this.map && this.pointMarkers.length) {
                this.map.remove(this.pointMarkers);
            }

            if (this.map && this.richMarker) {
                this.map.remove(this.richMarker);
            }

            if (this.map) {
                this.map.clearInfoWindow();
            }

            this.pointMarkers = [];
            this.richMarker = null;
        },
        tryRenderMarketMap() {
            if (!this.isMapReady || !this.landList.length) {
                return;
            }
            this.drawPolygonAndRichMark(this.landList);
        },
        initData(){
            this.getTimeArea();//统计时间
            this.getCityTop();//全装修项目建面TOP10城市
            this.getCompanyTop();//全装修项目建面TOP10房企
            this.getDeliveryCover();//房企全装修交付覆盖率
            this.getDecorateArea();//获取全装修的面积&套数
            this.getNewProjectList();//新开盘全装修项目列表
            this.getAreaDirection();//全装修项目面积趋势（饼图1&3）
            this.getDecorationStandard();//全装修项目面积趋势（饼图2）
            this.getProjectType();// 项目类型占比（饼图4）
            this.getProjectSpread();//全装修项目分布图（热力图）
        },
        // Echarts
        getOptions(echartType,obj) {
            switch (echartType) {
                case 'nestingPie':
                    let pieoption = getCharts.getNestingPieEchart(obj);
                    return pieoption;
                    break;
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj);
                    return baseoption;
                    break;
                case 'pie':
                    let trendoption = getCharts.getTrendPieEchart(obj);
                    return trendoption;
                    break;
                case 'donutPie'://尖角环形饼图
                    let option = getCharts.getDonutPieEchart(obj);
                    return option;
                    break;
                case 'mapBar'://地图柱状缩略图
                    let mapBarOption = getCharts.getMapBarEchart(obj,this.mapBarDataMax);
                    return mapBarOption;
                    break;
                default:
                    break;
            }
        },
        // 大屏切换
        showFullSwiper(){
            this.$emit('showFullSwiper');
        },
        // 热力图交互
        onHotmap(item){
            this.activeCity=item.CityCaption
        },
        // topList 点击跳转=>列表
        labelClick(type,name=''){
            let routeData = this.$router.resolve({
                path: '/page/market',
                query:{
                    activeTime:3,//近12个月
                    type:type,
                    name:name
                }
            });
	        window.open(routeData.href, this.isScreen?'_self':'_blank');
            // this.$router.push({
            //     path: '/page/market',
            //     query:{
            //         activeTime:3,//近12个月
            //     }
            // })
        },
        // 详情跳转
        toDetail(id){
            if(this.userType==1){
                this.showTip();
                return
            }
            let routeData = this.$router.resolve({
                path: '/page/detail',
                query:{
                    module:3,  
                    type:2,  
                    id:id,  
                }
            });
	        window.open(routeData.href, this.isScreen?'_self':'_blank');
            // this.$router.push({
            //     path: '/page/detail',
            //     query:{
            //         module:3,  
            //         type:2,  
            //         id:id,  
            //     }
            // })
        },

        // 新地图缩略柱状图相关
        /** 地图缩略图表增加click事件 */
        mapBarClick(params){
            let _city = this.mapBarData.filter(e => {
                return e.name == params.name ;
            })[0];

            let _arr = [] ;
            if(_city && _city.aList){
                _city.aList.forEach(e => {
                    if(!!e.X ){
                        _arr.push({
                            name:e.Caption,
                            invisor:e.Invisor,
                            coversArea:e.TotalBuildArea+'㎡',
                            salesPrice:e.FitmentPrice_Max + '万元',
                            center:[Number(e.X),Number(e.Y)],
                            PlanCounts:e.PlanCounts,
                            SolutionID:e.SolutionID,
                            X:Number(e.X),
                            Y:Number(e.Y)
                        });
                    }
                })
            }
            this.drawPolygonAndRichMark(_arr);
        },
        drawPolygonAndRichMark(_array){
            if (!this.map || !this.AMap) {
                return;
            }

            this.$nextTick(() => {
                this.clearMarketOverlays();
                let _Marks = [] ;
                _array.forEach(elem => {
                    const point = this.parsePoint([elem.X, elem.Y]);
                    if (point) {
                        let el = new this.AMap.Marker({
                            position: point,
                            content: this.getMarkHtml(),
                            offset: new this.AMap.Pixel(-6, -6),
                            zIndex: 180,
                        });
                        el.on('click', () => {
                            this.clickPolygon(elem);
                        });
                        _Marks.push(el);
                    }
                });

                if (_Marks.length) {
                    this.map.add(_Marks);
                }
                this.pointMarkers = _Marks;

                let _index = 0 ;

                clearInterval(this.MapTimmer);
                if(_array.length > 0){
                    this.resetRichMark(_array[0]);
                    _index ++ ;
                    this.MapTimmer = setInterval( () => {
                        if(_index == _array.length ){
                            _index  =  0 
                        }
                        if(_array.length != 0){
                            this.resetRichMark(_array[_index]);
                        }else {
                            clearInterval(this.MapTimmer );
                        }
                        _index ++ ;
                    },5000);
                }
            })
          
        },
        resetRichMark(elem){
            if(!elem.X){
                return false;
            }
            if (!this.map || !this.AMap) {
                return false;
            }

            if (this.richMarker) {
                this.map.remove(this.richMarker);
            }

            const point = this.parsePoint([elem.X, elem.Y]);
            if (point) {
                this.richMarker = new this.AMap.Marker({
                    position: point,
                    content: this.getOverlayHtml(elem),
                    offset: new this.AMap.Pixel(0, 0),
                    zIndex: 300,
                });
                this.richMarker.on('click', () => {
                    this.toDetail(elem.SolutionID)
                });
                this.map.add(this.richMarker);
                this.map.panTo(point);
            }
        },
        clickPolygon(elem){
            clearInterval(this.MapTimmer);
            this.resetRichMark(elem);
        },
        getMarkHtml(){
            return `<div class="market-map-dot"></div>`
        },
        getOverlayHtml(currentMapInfo){
            // <div class="od-title">${currentMapInfo.name}</div>
            return `<div class="amap-market-overlay-marker">
                        <div class="overlay--details green">
                            <div class="od-info">
                                <div class="items">
                                    <div class="label">项目名称：</div>
                                    <div class="value" title="${currentMapInfo.name}">${currentMapInfo.name}</div>
                                </div>
                                <div class="items">
                                    <div class="label">项目开发商：</div>
                                    <div class="value" title="${currentMapInfo.invisor}">${currentMapInfo.invisor}</div>
                                </div>
                                <div class="items">
                                    <div class="label">总建面积：</div>
                                    <div class="value">${currentMapInfo.coversArea}</div>
                                </div>
                                <div class="items">
                                    <div class="label">规划户数：</div>
                                    <div class="value">${currentMapInfo.PlanCounts}</div>
                                </div>
                            </div>
                            <div class="od-point"></div>
                            <div class="line-45">
                                <div class="ins"></div>
                            </div>
                        </div>
                    </div>`
        },
        // ============================API==========================

        // 全装修统计时间
        getTimeArea(){
            ajaxService.getCountTime().then(res=>{
                if(!res.ErrorCode){
                    this.countTime=res.Data
                }
            })
        },
        // 全装修项目建面TOP10城市       
        getCityTop(){
            ajaxService.getDecorateBuildTopTenCity().then(res=>{
                // console.log('城市',res)
                if(!res.ErrorCode){
                    this.cityTopTenData=res.Data
                }
            })
        },
        // 全装修项目建面TOP10房企      
        getCompanyTop(){
            ajaxService.getDecorateBuildTopTenCompany().then(res=>{
                // console.log('房企',res)
                if(!res.ErrorCode){
                    this.companyTopTenData=res.Data
                }
            })
        },
        // 房企全装修交付覆盖率      
        getDeliveryCover(){
            ajaxService.decorateBuildCompanyCover().then(res=>{
                // console.log('交付覆盖率',res)
                if(!res.ErrorCode){
                    this.deliveryCoverData=res.Data
                }
            })
        },
        // 获取全装修的面积&套数      
        getDecorateArea(){
            ajaxService.getDecorateAreaAndCount().then(res=>{
                // console.log('双折线图',res)
                if(!res.ErrorCode){
                    this.areaCountHead=res.Data.AreaAndCount
                    this.areaCountChart=res.Data.aList
                }
            })
        },
        // 新开盘全装修项目列表     
        getNewProjectList(){
            ajaxService.getNewOpenDecorationProject().then(res=>{
                // console.log('新开盘全装修项目列表',res)
                if(!res.ErrorCode){
                    this.newProjectListData=res.Data
                }
            })
        },
        // 建筑面积占比     
        getAreaDirection(){
            ajaxService.getDecorationAreaDirection().then(res=>{
                // console.log('建筑面积占比',res)
                if(!res.ErrorCode){
                    this.areaDirection=res.Data
                }
            })
        },
        // 装修标准占比     
        getDecorationStandard(){
            ajaxService.getDecorationStandardDirection().then(res=>{
                // console.log('装修标准占比',res)
                if(!res.ErrorCode){
                    this.decorationStandard=res.Data
                }
            })
        },
        // 项目类型占比     
        getProjectType(){
            ajaxService.getDecorationStandardDirectionCate().then(res=>{
                // console.log('项目类型占比',res)
                if(!res.ErrorCode){
                    this.projectTypeData=res.Data
                }
            })
        },
        // 全装修项目分布图（热力图）（新——mapbar）  
        getProjectSpread(){
            // ajaxService.getDecorationProjectSpread().then(res=>{
            //     console.log('热力图',res)
            //     if(!res.ErrorCode){
            //         this.projectSpreadData=res.Data.aList
            //         let arr = []
            //         if(res.Data.aList&&res.Data.aList.length){
            //             res.Data.aList.forEach(item=>{
            //                 arr.push(item.count)
            //             })
            //         }
            //         // 画热力图
            //         let max=this.$UtilTool.calMax2(arr)
            //         drawHotmap(this.map,this.projectSpreadData,max)
            //     }
            // })
            ajaxService.getDecorationProjectSpreadNew().then(res=>{
                console.log('地图新',res)
                if(!res.ErrorCode){
                    this.mapBarData = res.Data.map( e => {
                        return {
                            name: e.CityCaption,
                            value: e.count,
                            aList: e.aList
                        }
                     });

                     this.mapBarDataMax = Math.max(...res.Data.map(e => {
                         return e.count 
                     }));

                     this.landList = [] ;

                     this.mapBarData.forEach(el => {
                         el.aList.forEach(e => {
                             if(!!e.X ){
                                this.landList.push({
                                    name:e.Caption,
                                    invisor:e.Invisor,
                                    coversArea:e.TotalBuildArea+'㎡',
                                    salesPrice:e.FitmentPrice_Max + '万元',
                                    PlanCounts:e.PlanCounts,
                                    SolutionID:e.SolutionID,
                                    center:[Number(e.X),Number(e.Y)],
                                    X:Number(e.X),
                                    Y:Number(e.Y)
                                });
                             }
                         })
                     })

                    this.$nextTick( () => {
                        this.tryRenderMarketMap();
                    })
                }
            })
        },

        
    },
}
</script>
<style lang="scss" scoped>
@use '../../assets/styles/mixin' as *;
.logo{
    background-image: url('../../assets/imgs/logo_market.png');
    top: 4.4vh;
}
.menu{
    background-image: url('../../assets/imgs/menu_market.png');
}
header{
    height: 10vh;
    box-sizing: border-box;
    padding-top: 4vh;
    text-align: center;
    .title{
        font-size:.4rem;
        font-weight: bold;
        @include text_gradient(top,#FFFFFF,#50B8D1);
    }
    .title--sub{
        font-size:.18rem;
        color: #fff;
        line-height: 2.5;
    }
}

.box_normal{
    border: .02rem solid rgba($color: #182c57, $alpha: 0.3);
    background-color: rgba($color: #051a27, $alpha: 0.3);
}

.box_map{
    background: none;
    border: .02rem solid rgba($color: #182c57, $alpha: 0.3);
    background-color: rgba($color: #051a27, $alpha: 0.3);
    &.subscript{
        &::after{
            right: -.02rem;
        }
        &::before{
            left: -.02rem;
        }
    }
}

.box_cutAngle--bg{
    border-left: .02rem solid rgba($color: #02ccff, $alpha: 0.4);
    background-image: url('../../assets/imgs/project_angle_bg01.png'),url('../../assets/imgs/project_angle_bg02.png');
}

.cutAngle_box{
    width: 100%;
    height: 54.4vh;
    background-image: url('../../assets/imgs/project_angle_bg03.png'),url('../../assets/imgs/project_angle_bg04.png');
}

.box_chart--doubleLine{
    .detailBox{
        .item{
            .value{
                font-size: .4rem;
                line-height: 1.5;
            }
        }
    }
}

.pieChartList{
    position: absolute;
    right: .1rem;
    top:0;
    .label{
        display: inline-block;
        width: .8rem;
    }
    .value{
        font-size: .14rem !important;
    }
}


.mapTitle{
    width: 13.2vw;
    height: 4.5vh;
    font-size: .2rem;
    line-height: 4.3vh;
    box-sizing: border-box;
    padding-left: .6rem;
    font-weight: bold;
    color: white;
    background: url('../../assets/imgs/market_mapTitle.png') 0 0 no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: .02rem;
    top: .03rem;
}

// swiper
.swiper_icon{
    font-size: .2rem;
    color: #00FFFF;
    position: absolute;
    top: .2rem;
    z-index: 11;
    cursor: pointer;
    outline: none;
    &.disabled{
        display: none;
    }
}
.arrow_l{
    @extend .swiper_icon;
    left: .2rem;
}
.arrow_r{
    @extend .swiper_icon;
    right: .2rem;
}

.hotmapList{
    background: rgba($color: #152f49, $alpha: 0.9)
}

.map-content {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    :deep(.amap-market-overlay-marker) {
        position: relative;
        width: 0;
        height: 0;
        overflow: visible;
        cursor: pointer;
    }
    :deep(.amap-market-overlay-marker .overlay--details) {
        pointer-events: auto;
    }
    :deep(.market-map-dot) {
        width: 0.12rem;
        height: 0.12rem;
        border-radius: 50%;
        background: rgba(0, 255, 255, 0.95);
        border: 1px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 0 0 4px rgba(0, 255, 255, 0.18);
        cursor: pointer;
    }
}

.map-chart {
    position: absolute;
    width: 30%;
    height: 41%;
    background:#000;
    border:2px solid rgba(6, 104, 186, 0.5);
    bottom: 0.1rem;
    right: 0.1rem;
    z-index: 10;
    pointer-events: auto;
}

</style>
